import countriesMap from '@localization/countries.json'
import {
  useCheckMMUserCountry,
  useCheckUserCountry,
} from './useCheckUserCountry'
import { useCountriesData } from './useCountriesData'
import { useUserSession } from './useUserSession'
import { erpSystemTypes } from '@src/routes'
import { useCurrentUser } from '@utils/useCurrentUser'
import getConfig from 'next/config'
import { useMemo } from 'react'

const {
  publicRuntimeConfig: { discoEnabledCountries },
} = getConfig()

export const useIsTaxExempt = (): boolean => {
  const isUsUser = useCheckUserCountry(countriesMap.US.countryCode)
  const isCanadaUser = useCheckUserCountry(countriesMap.CA.countryCode)
  return isUsUser || isCanadaUser
}

export const useInvoiceEmailEligibleUser = (): boolean => {
  const { userSession } = useUserSession()
  const eligibleCountries = [
    countriesMap.SE.countryCode,
    countriesMap.DK.countryCode,
    countriesMap.NO.countryCode,
    countriesMap.FI.countryCode,
    countriesMap.GB.countryCode,
    countriesMap.BE.countryCode,
    countriesMap.NL.countryCode,
    countriesMap.LU.countryCode,
    countriesMap.IE.countryCode,
    countriesMap.DE.countryCode,
    countriesMap.CH.countryCode,
    countriesMap.AT.countryCode,
    countriesMap.FR.countryCode,
    countriesMap.IT.countryCode,
    countriesMap.ES.countryCode,
    countriesMap.PT.countryCode,
  ]

  const userCountry = userSession.country.toLocaleUpperCase()

  return eligibleCountries.includes(userCountry)
}

export const useDiscoPromotionEligibleUser = (): boolean => {
  const { userSession } = useUserSession()

  const userCountry = useMemo(
    () => userSession.country.toLocaleUpperCase(),
    [userSession.country]
  )

  return useMemo(
    () => discoEnabledCountries?.includes(userCountry),
    [userCountry, discoEnabledCountries]
  )
}

export const useIsIscalaCountry = (): boolean => {
  const { erpSystemId } = useCurrentUser()
  return erpSystemId === erpSystemTypes.Iscala
}

export const useIsQrpCountry = (): boolean => {
  const { userSession } = useUserSession()
  const { getCountryDetails } = useCountriesData()

  const userCountryInfo = getCountryDetails(
    userSession.country.toLocaleUpperCase()
  )
  return userCountryInfo.erpSystemId === erpSystemTypes.Qrp
}

export const useCheckMOQLessThanCountry = () => {
  const isIndonesiaUser = useCheckUserCountry(countriesMap.ID.countryCode)
  const isTWUser = useCheckUserCountry(countriesMap.TW.countryCode)
  const isINMMUser = useCheckMMUserCountry(countriesMap.IN.countryCode)
  const isSGMMUser = useCheckMMUserCountry(countriesMap.SG.countryCode)

  return isIndonesiaUser || isTWUser || isINMMUser || isSGMMUser
}

export const useWebOnlyPromoCountry = (): boolean => {
  const { userSession } = useUserSession()
  const eligibleCountries = [
    countriesMap.US.countryCode,
    countriesMap.AU.countryCode,
    countriesMap.NZ.countryCode,
    countriesMap.JP.countryCode,
    countriesMap.AS.countryCode,
    countriesMap.FR.countryCode,
    countriesMap.DE.countryCode,
    countriesMap.CH.countryCode,
  ]

  const userCountry = userSession.country.toLocaleUpperCase()

  return eligibleCountries.includes(userCountry)
}
